import React, {useEffect, useContext } from "react";
import { useLocation, useNavigate} from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { AiOutlineRight } from "react-icons/ai";
import { ThemeContext } from '../../contexts/ThemeContext';
import "./Breadcrumb.css";

const removeVietnameseTones = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
};

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext);
  const pathnames = location.pathname.split("/").filter((x) => x);
  const firstParam = pathnames.length > 0 ? removeVietnameseTones(pathnames[0]) : null;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  const breadcrumbMap = {
    "phim-bo": "Phim Bộ",
    "phim-le": "Phim Lẻ",
    "hoat-hinh": "Hoạt Hình",
    "tv-shows": "TV Shows",
    "quoc-gia": "Quốc gia",
    "nam": "Năm phát hành",
    "kr": "Hàn Quốc",
    "the-loai": "Thể loại",
    "lich-su": "Lịch sử xem phim",
  };

  const handleNavigateHome = () => {
    navigate("/trang-chu");
  };

  return (
    <nav className="breadcrumb-container">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <button
            onClick={handleNavigateHome}
            className="breadcrumb-item-a"
          >
            <FaHome style={{ marginRight: "5px", width: "0.85rem", height: "0.85rem" }} />
            Trang chủ
          </button>
          {firstParam && <AiOutlineRight className="breadcrumb-separator" />}
        </li>
        {firstParam && (
          <li className="breadcrumb-item active">
            {breadcrumbMap[firstParam] || firstParam}
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
